export const GET_CURRENT_ORGANIZATION_START =
  'GET_CURRENT_ORGANIZATION_START';
export const GET_CURRENT_ORGANIZATION_END =
  'GET_CURRENT_ORGANIZATION_END';
export const GET_CURRENT_ORGANIZATION_SUCCESS =
  'GET_CURRENT_ORGANIZATION_SUCCESS';
export const GET_CURRENT_ORGANIZATION_FAILURE =
  'GET_CURRENT_ORGANIZATION_FAILURE';
